import React, { useEffect, useState } from "react";
import "./Place.css";
import { Flex, Header, SafeArea } from "../../components/layout";
import { Text } from "../../components/ui";
import { ImQuotesLeft } from "react-icons/im";
import Masonry from "../../components/layout/masonry/Masonry";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../components/firebase/firebase";
import { logEvent, serializeError } from "../../utils/logger";

function Place() {
  const [data, setData] = useState([]);

  const fetchArticles = async () => {
    try {
      let dataQuery = query(
        collection(db, "photos"), // ✅ Utilisation correcte de collection()
        orderBy("name"), // ✅ Tri par date descendante
      );

      const querySnapshot = await getDocs(dataQuery); // ✅ Récupération des documents
      querySnapshot.forEach((doc) => {
        setData((data) => [...data, doc.data().img]);
      });
    } catch (error) {
      console.error("Erreur lors du chargement des articles :", error);
      logEvent("ERROR", "DB", "Failed to fetch photos", {
        error: serializeError(error),
        collection: "photos",
      });
    }
  };
  useEffect(() => {
    fetchArticles();
  }, []);
  return (
    <SafeArea className="Place">
      <Flex type="col" gap={50}>
        <Header title="Le Lieu">
          Au gré des 4 saisons, vous serez émerveillés par la{" "}
          <span>diversité et la beauté des éléments</span>. <br />
          Notre chalet d’alpage <span>
            authentique, simple et chaleureux
          </span>{" "}
          situé à 1500 mètres d'altitude permet d’accueillir 8 à 10 stagiaires.
        </Header>
        <Text></Text>
        <Flex type="col-center" gap={150}>
          <Flex type="col-center" gap={50}>
            <ImQuotesLeft className="icon" />
            <Flex type="col-center" className="poem" gap={13}>
              <Text>L’authenticité de la pierre</Text>
              <Text>La chaleur enveloppante du bois</Text>
              <Text>Le doux crépitement du feu dans la cheminée</Text>
              <Text>La chanson frissonnante des torrents</Text>
              <Text>
                L’ancrage des arbres et le murmure des leurs feuilles dans le
                vent
              </Text>
              <Text>
                L’explosion de couleurs des fleurs au printemps et des feuilles
                en automne
              </Text>
              <Text>Le silence feutré de la neige</Text>
              <Text>L’allégresse du chant des oiseaux</Text>
              <Text>Le parfum envoutant des sous-bois</Text>
              <Text>La puissance immuable des montagnes</Text>
            </Flex>
            <ImQuotesLeft className="icon" />
          </Flex>
          <Masonry images={data} />
        </Flex>
      </Flex>
    </SafeArea>
  );
}

export default Place;
